import React from 'react'

const Footer = (props) => (
    <footer id="footer">
        <div className="inner">
            <ul className="copyright">
                <li>&copy; NEA X GmbH</li>
                <li><a href="/imprint/#">Imprint</a></li>
                <li><a href="/privacy/#">Privacy Policy</a></li>
            </ul>
        </div>
    </footer>
)

export default Footer
